require("./src/treeGrid.css");
module.exports = require("./src/tree-grid-directive.js");


//////////////////
// WEBPACK FOOTER
// angular-bootstrap-grid-tree (bower component)
// module id = 354
// module chunks = 0